import { FC } from 'react'
import { TextField } from '@mui/material'
import { useForm } from 'react-hook-form'

interface IFormOfNumberProps {
  tempValue: string
  inputError: boolean
  setTempValue: (param: string) => void
}

export const FormOfNumber: FC<IFormOfNumberProps> = ({ tempValue, inputError, setTempValue }) => {
  const { register } = useForm()
  return (
    <TextField
      value={tempValue}
      error={inputError}
      inputProps={{
        style: {
          background: '#F7F7F7',
          border: '1px solid #D4D4D4',
          fontSize: '16px',
          padding: '8px',
        },
      }}
      {...register('number', {
        pattern: /d+/,
        onChange: (e) => setTempValue(e.target.value),
      })}
    />
  )
}
